import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmationService } from '../../core/services/confirmation.service';
import { ModalComponent } from '../ui-modal/modal.component';
import { ButtonComponent } from '../ui-button/button.component';

@Component({
  selector: 'app-confirmation-dialog',
  standalone: true,
  imports: [CommonModule, ModalComponent, ButtonComponent],
  template: `
    @if (confirmationService.showModal()) {
      <app-modal
        [title]="confirmationService.options()?.title || 'Вы уверены?'"
        size="sm"
        (close)="confirmationService.onCancel()"
        [closeOnOverlay]="false"
        [showFooter]="true"
      >
        <p class="message">{{ confirmationService.options()?.message }}</p>
        <div footer class="footer-content">
          <app-button
            variant="secondary"
            (clicked)="confirmationService.onCancel()"
          >
            {{ confirmationService.options()?.cancelLabel || 'Отмена' }}
          </app-button>
          <app-button
            variant="primary"
            (clicked)="confirmationService.onConfirm()"
          >
            {{ confirmationService.options()?.confirmLabel || 'Подтвердить' }}
          </app-button>
        </div>
      </app-modal>
    }
  `,
  styles: [`
    .message {
      margin: 0;
      color: var(--text-primary);
      font-size: 14px;
      line-height: 1.5;
    }

    .footer-content {
      display: flex;
      gap: 12px;
      justify-content: flex-end;
    }
  `]
})
export class ConfirmationDialogComponent {
  protected confirmationService = inject(ConfirmationService);
}
